import React from "react";

const Button = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  fullWidth = false,
  className = "",
  disabled = false,
}) => {
  const baseStyles =
    "font-semibold rounded-xl transition-all duration-300 ease-in-out transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-primary/40";

  const variants = {
    primary:
      "bg-primary-gradient text-white hover:brightness-110 shadow-md shadow-primary/25 px-6 py-3",
    secondary:
      "bg-transparent text-[var(--color-primary)] border border-primary/60 hover:bg-primary/10 px-6 py-3",
    icon: "bg-[var(--bg-card)] text-[var(--color-primary)] hover:bg-primary/10 p-3",
  };

  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${widthClass} ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
